import Keycloak from 'keycloak-js';

const keycloakConfig = {
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
};

const keycloak = new Keycloak(keycloakConfig);
let initPromise = null;

const loginRedirectUri = window.location.origin + '/';

/**
 * Keycloak 26.x: standard OIDC code flow + PKCE, login iframe off. No onLoad
 * (no check-sso / prompt=none request): init only processes the code returned
 * in the URL fragment after keycloak.login() redirects back to the app root.
 */
const initOptions = {
  flow: 'standard',
  pkceMethod: 'S256',
  checkLoginIframe: false,
};

export const ensureKeycloakInitialized = () => {
  if (!initPromise) {
    initPromise = keycloak
      .init(initOptions)
      .then(authenticated => {
        keycloak.initialized = true;
        if (authenticated) {
          sessionStorage.setItem('keycloakAuthenticated', 'true');
          setInterval(() => {
            keycloak.updateToken(70).catch(() => {
              keycloak.logout();
            });
          }, 60000);
        } else {
          sessionStorage.removeItem('keycloakAuthenticated');
        }
        return authenticated;
      })
      .catch(error => {
        sessionStorage.removeItem('keycloakAuthenticated');
        console.error('Keycloak initialization failed', error);
        throw error;
      });
  }
  return initPromise;
};

export const initializeKeycloak = onAuthenticatedCallback => {
  ensureKeycloakInitialized()
    .then(authenticated => {
      if (!authenticated) {
        sessionStorage.removeItem('keycloakAuthenticated');
      }
      onAuthenticatedCallback(authenticated);
    })
    .catch(error => {
      console.error('Keycloak session check failed', error);
      onAuthenticatedCallback(false);
    });
};

export const loginUser = () => {
  ensureKeycloakInitialized()
    .then(authenticated => {
      if (authenticated) {
        sessionStorage.setItem('keycloakAuthenticated', 'true');
        return;
      }
      // Explicit redirect to Keycloak (KC 26+); interactive login completes the code flow
      keycloak.login({ redirectUri: loginRedirectUri }).catch(error => {
        console.error('Keycloak login redirect failed', error);
      });
    })
    .catch(error => {
      console.error('Keycloak init before login failed', error);
      keycloak.login({ redirectUri: loginRedirectUri }).catch(loginError => {
        console.error('Keycloak login redirect failed', loginError);
      });
    });
};

export const isUserAuthenticated = () =>
  keycloak.authenticated && sessionStorage.getItem('keycloakAuthenticated') === 'true';

export const isTokenValid = () => keycloak.token && !keycloak.isTokenExpired();

export const logoutUser = () => {
  // Clear all session storage
  sessionStorage.clear();
  // Clear any local storage if used
  localStorage.clear();
  // Call keycloak logout with proper redirect
  keycloak.logout({
    redirectUri: window.location.origin,
  });
};

export default keycloak;
